import { useEffect, useRef, useState } from "react";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { json_utils } from "../utils/frfr-json-utils";
import { rapidozi_dummy_utils, rapidozi_dummysmarty_utils, smartydummy_backend_special_instance } from "../utils/frfr-rapidozi-dummy-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import Btn from "./Btn";
import CardCollapsible from "./CardCollapsible";
import JSDisplayValue from "./JSDisplayValue";
import JSUniValueEditor from "./JSUniValueEditor";
import Komentar from "./Komentar";
import UniBtn, { UniBtnPack } from "./UniBtn";
import UniImage from "./UniImage";
import ViewGeneratorSimpleV3 from "./ViewGeneratorSimpleV3";
import { frfr_res_utils } from '../utils/frfr-res-utils';
import { js_utils } from "../utils/frfr-js-utils";
import {
  _zzyourmap_formDefinition_formPart_editing, _zzyourmap_formDefinition_adminLogin,
  _zzyourmap_preset_destination,
  _zzyourmap_formDefinition_destination,
  _zzyourmap_formDefinition_destination_formPart_main_img,
  _zzyourmap_prepare_entbox_for_submit_destination,
  _zzyourmap_preset_smestaj,
  _zzyourmap_formDefinition_smestaj,
  _zzyourmap_formDefinition_smestaj_formPart_parent_destinacija_id, _zzyourmap_formDefinition_smestaj_formPart_kontakt, _zzyourmap_formDefinition_smestaj_formPart_checks, _zzyourmap_formDefinition_smestaj_formPart_main_img, _zzyourmap_formDefinition_smestaj_formPart_gallery, _zzyourmap_formDefinition_smestaj_formPart_marker,
  _zzyourmap_prepare_entbox_for_submit_smestaj,
  _zzyourmap_preset_ostalo_v1,
  _zzyourmap_formDefinition_ostalo_v1,
  _zzyourmap_prepare_entbox_for_submit_ostalo_v1,
  _zzyourmap_formDefinition_ymthing_prefilter_vr_tablename
} from "../utils/zz/zz-yourmap-admin-form-utils";
import FormGenerator from "./FormGenerator";
import YourmapImageLibraryV4 from "./YourmapImageLibraryV4";
import { useHandleInputChange } from "../hooks/useHandleInputChange";
import UniSpinnerClassic from "./UniSpinnerClassic";
import YourmapLeafletContainerUniversal from "./YourmapLeafletContainerUniversal";
import UniLimiter from "./UniLimiter";
import YourmapEditorjsDemoV1 from "./YourmapEditorjsDemoV1";
import YourmapMapPageWrapper from "./YourmapMapPageWrapper";
import UniIndent from "./UniIndent";
import { _zzyourmap_extract_map_props_1_for_smestaj_position_picker } from "../utils/zz/zz-yourmap-map-utils";
import FrfrAlienEditorjsRendererV1 from "./FrfrAlienEditorjsRendererV1";
import HelpWidget from "./HelpWidget";
import YourmapEditorjsV2 from "./YourmapEditorjsV2";
import { _zzyourmap_img_url_full_from_parts } from "../utils/zz/zz-yourmap-image-utils";
import { _zzyourmap_extract_editorjs_renderable_data, _zzyourmap_update_special_blog_post_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import YourmapDocs from "./YourmapDocs";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import FormFieldGenerator from "./FormFieldGenerator";
import ViewGeneratorSimpleV4 from "./ViewGeneratorSimpleV4";
import { app_build_version_id_zzyourmap, _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
// import { app_build_version_id } from "../index.js"; // Use ../ to get up from components folder


//
const YourmapAdminMapDemoV1 = (props) => {
  const {
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.appPack;
  // console.log('geouri za canada bariff je: geo:51.2,-159.6?z=2');
  const [imgSrcBlob, setImgSrcBlob] = useState(null);
  //
  // let _img_url = '/static/img/photoshop-checkboard-pattern-20px-flipped.png';
  let _img_url = '/static/img/frfr-image-placeholder-xgradient-1024x1024px.png';
  // let _img_url = 'https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d30f4d7f74.jpg'; // mapa bajina basta uploadovana
  const [markers, setMarkers] = useState([]);
  const [newMarkerState, setNewMarkerState] = useState({
    left: 0,
    bottom: 0,
    // marker_img_src: _img_url,
    marker_img_src: null,
    tooltip_text: 'Naslov u popupu',
    iconAnchor: [10, 10],
    img_class: "ym-script__marker__icon-img ym-script__marker__icon-bounce-2",
  });

  const cbPickSingleImage_admin = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    //
    const src = _zzyourmap_img_url_full_from_parts(img_filename, img_folder);
    //
    setImgSrcBlob(src);
    setNewMarkerState(newMarkerState => {
      return {
        ...newMarkerState,
        // bottom: Number.parseInt(bottom),
        // left: Number.parseInt(left),
        // size: 40,
        w: 40,
        h: 40,
        marker_img_src: src,
      };
    });
    setUniModalPortableClose();
  };

  const _cbClickLatLng = (bottom, left) => {
    console.log(bottom, left, typeof bottom, typeof left);
    setNewMarkerState(newMarkerState => {
      return {
        ...newMarkerState,
        bottom: Number.parseInt(bottom),
        left: Number.parseInt(left),
        // size: 40,
        w: 40,
        h: 40,
        marker_img_src: newMarkerState.marker_img_src,
      };
    });
  };


  const handleAddMarker = () => {
    /*
    setNewMarkerState(state => {
      return {
        ...state,
        markers_arr: [...state.markers_arr, {
          bottom: state.bottom,
          left: state.left,

        }],
      };
    });
    */
    setMarkers(markers => {
      return [...markers, {
        ...newMarkerState,
        // marker_img_src: imgSrcBlob,
      }];
    });
  };

  // demo mapa ym-demo-mapa.jpg 6050x3050px
  const demo_map_img_url = _zzyourmap_config.demo_map_img_url_full;

  let options = {
    enableClickLatLng: true, // enable pick lat lng coordinates
    _cbClickLatLng,
    markers_arr: markers,
    // demo-mapa
    map_img_url: demo_map_img_url,
    w: 6050,
    h: 4301,
  };

  return (
    <>
      <section className="yourmap__section yourmap__section--map222">
        <div className="inner">
          <div>
            <Komentar>
              <p>- Za koordinate na mapi koristimo 'left' i 'bottom'<br />to su brojevi koliko pixela od levog ruba slike odnosno od dna slike.</p>
              <p>primeri url do slike:</p>
              <p>/static/img/frfr-image-placeholder-xgradient-1024x1024px.png</p>
              <p>/static/img/banner-placeholder-250x250.png</p>
              <p>/static/img/photoshop-checkboard-pattern-20px.png</p>
            </Komentar>
            {/*
            state:
            <JSDisplayValue val={newMarkerState} />
            */}
            markers state:
            <JSDisplayValue val={markers} />
            new marker state:
            <div className="uu-text-nowrap">
              <JSUniValueEditor val={newMarkerState} cbSetVal={setNewMarkerState} />
            </div>
            <div className="uu-gap-standalone-1rem"></div>
            <div className="uu-vector uu-vector--col uu-gaps-m-1rem">
              <div>
                <UniBtn
                  inline
                  wide
                  circle
                  i="fa fa-picture-o"
                  title="Pick/Choose/Upload Image Icon"
                  handleClick={() => {
                    setUniModalPortableContent({
                      options: {
                        large: true,
                      },
                      jsx: (
                        <>
                          <YourmapImageLibraryV4
                            appPack={props.appPack}
                            cbPickSingleImage={cbPickSingleImage_admin}
                            enableSelectSingular={true}
                          />
                        </>
                      ),
                    });
                  }}
                />
              </div>
              <div>
                marker icon preview:
                <div className="uu-vector">
                  <UniImage src={newMarkerState.marker_img_src} extraClass="yourmap__theme__image-lib-figure" />
                </div>
              </div>
              <div>
                <UniBtn
                  disabled={newMarkerState.marker_img_src ? false : true}
                  inline
                  circle
                  wide
                  i="fa fa-plus"
                  title="Add marker on map"
                  handleClick={handleAddMarker}
                />
              </div>
            </div>
            <p>...open/close to refresh</p>
          </div>
        </div>

        <CardCollapsible fullWidth title="* DEMO Map Preview">
          <section className="yourmap__section yourmap__section--map">
            <div className="inner">
              <div className="yourmap__map">
                <YourmapMapPageWrapper
                  mapFetching={false}
                >
                  <YourmapLeafletContainerUniversal ll={[51.2, -159.6]} options={options} />
                </YourmapMapPageWrapper>

                {/*
                <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={false}>
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <Marker position={[51.505, -0.09]}>
                    <Popup>
                      A pretty CSS3 popup. <br /> Easily customizable.
                    </Popup>
                  </Marker>
                </MapContainer>
                */}
              </div>
            </div>
          </section>
        </CardCollapsible>
      </section>
    </>
  );
};


// ---------- Yourmap ADMIN PANEL


//
const FormPartDestinationMainImg = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_destination_formPart_main_img()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span>Pick main image </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload Image"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 22,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickSingleImage={cbPickSingleImage}
                    enableSelectSingular={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
    </>
  );
};


//
const YourmapFormDestination = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  const {
    options_adm_parent_of_destination,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;
  //
  let initialState;
  let formDefinition;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
    // formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_destination];
  } else {
    initialState = { ..._zzyourmap_preset_destination };
    // formDefinition = _zzyourmap_formDefinition_destination;
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  if (editMode) {
    formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_destination(state, options_adm_parent_of_destination)];
  } else {
    formDefinition = _zzyourmap_formDefinition_destination(state, options_adm_parent_of_destination);
  }
  let _show_pickers = false;
  let _show_main_img_pickers = false;
  let _show_map_pickers = false;
  if (state?.destinacija_tip === "DESTINATION") {
    _show_main_img_pickers = true;
  }
  if (state?.destinacija_tip === "DESTINATION" || state?.destinacija_tip === "SUBDESTINATION") {
    _show_map_pickers = true;
    _show_pickers = true;
  }

  //
  const cbPickSingleImage = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        destinacija_main_img_filename: img_filename,
        destinacija_main_img_folder: img_folder,
      };
    });
  };
  const cbPickSingleImage_2 = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK 2', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        destinacija_map_img_filename: img_filename,
        destinacija_map_img_folder: img_folder,
      };
    });
  };
  //
  const formPart_pack = {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    // cbPickMultipleImages,
    // subformGalleryArr,
    // options,
  };
  //
  return (
    <div className="unicompo-various-content yourmap-theme__scope-admin-panel">
      <h3 className="uu-mt-0">{editMode ? ('Izmeni destinaciju') : ('Dodaj novu destinaciju')}</h3>
      <Komentar extraClass="uu-max-w-360px yourmap__dev-komentar-in-form">
        Ukoliko je u pitanju poddestinacija, polja '<b>destinacija_naslov</b>' i '<b>destinacija_slug</b>' ostavite prazno. U svim ostalim slučajevima, sva teksulana polja bi trebalo popuniti.
      </Komentar>
      <div>
        <FormGenerator
          formDefinition={formDefinition}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      {
        _show_map_pickers === true && (
          <>
            <div className="uu-gap-standalone-05rem"></div>
            <div>
              <span>Pick map image </span>
              <UniBtn
                inline
                wide
                circle
                size={24}
                i="fa fa-picture-o"
                title="Pick/Upload Image"
                handleClick={() => {
                  setUniModalPortableContent_2({
                    options: {
                      large: true,
                      zIndex: 22,
                    },
                    jsx: (
                      <>
                        <YourmapImageLibraryV4
                          appPack={props.appPack}
                          cbDialogCancel={setUniModalPortableClose_2}
                          cbPickSingleImage={cbPickSingleImage_2}
                          enableSelectSingular={true}
                        />
                      </>
                    ),
                  });
                }}
              />
            </div>
          </>
        )
      }
      {
        _show_main_img_pickers === true && (
          <>
            {/* formPart MAIN IMAGE */}
            <FormPartDestinationMainImg appPack={props.appPack} formPart_pack={formPart_pack} />
          </>
        )
      }
      <div className="uu-gap-standalone-1rem"></div>
      <div className="uu-gap-standalone-1rem"></div>
      <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
        <UniBtn
          disabled={_show_pickers !== true}
          inline
          wide
          circle_EX
          i="fa fa-paper-plane"
          title="Submit"
          handleClick={() => {
            // cbDialogSubmit(state);
            const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_destination(state);
            if (editMode) { // EDIT
              const payload = { of_id: state.of_id };
              cbDialogSubmit(prepared_entbox, payload);
            } else { // ADD
              cbDialogSubmit(prepared_entbox);
            }
            // cbDialogCancel();
          }}
        />
        <UniBtn
          disabled={false}
          inline
          wide
          outline
          circle_EX
          i="fa fa-times"
          title="Cancel"
          handleClick={() => { cbDialogCancel(); }}
        />
      </div>
      <div className="uu-gap-standalone-1rem"></div>
    </div>
  );
};


//
const FormPartKontakt = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_kontakt()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span><a target="_blank" rel="noopener noreferrer" href="https://www.openstreetmap.org/?#map=17/43.285457/20.809350">* Find Geo URI here</a></span>
      </div>
    </>
  );
};


//
const FormPartChecks = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_checks()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
    </>
  );
};


//
const FormPartMainImg = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_main_img()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div><span>Pick main image </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload Image"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 22,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickSingleImage={cbPickSingleImage}
                    enableSelectSingular={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
    </>
  );
};


//
const FormPartGallery = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    setSubformGalleryArr,
    options,
  } = formPart_pack;
  //
  const adm_slide_img_src_arr = [];
  if (Easy69_v1.is_array(subformGalleryArr)) {
    subformGalleryArr.forEach(gallery_img => {
      adm_slide_img_src_arr.push({
        src: _zzyourmap_img_url_full_from_parts(gallery_img, 'uploads'),
        img_filename: gallery_img,
      });
    });
  }
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_gallery()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div className="uu-text-nowrap uu-pl-16px">
        <div className="yourmap__image-library__admin-gallery">
          {
            adm_slide_img_src_arr.map((gallery_item, index) => {
              // <div>{gallery_item}</div>
              const src = gallery_item.src;
              const img_filename = gallery_item.img_filename;
              return (
                <div className={"yourmap__image-library__admin-gallery__item yourmap__image-library__item"}>
                  <div className="yourmap__image-library__tail">
                    <div className="yourmap__image-library__actions">
                      <div className="uu-vector uu-vector-row uu-gaps-p-05rem uu-vector--items-center">
                        <div>
                          <UniBtnPack pill>
                            <UniBtn
                              wide_NOT
                              circle
                              size={16}
                              i="fa fa-caret-left"
                              title_NOT="EDIT"
                              tooltip="Move left"
                              themeCompoColorBlue
                              handleClick={() => {
                                setSubformGalleryArr(old_arr => {
                                  return js_utils.array_item_move_pure(old_arr, index, -1);
                                });
                              }}
                            />
                            <UniBtn
                              wide_NOT
                              circle
                              size={16}
                              i="fa fa-caret-right"
                              title_NOT="EDIT"
                              tooltip="Move right"
                              themeCompoColorBlue
                              handleClick={() => {
                                setSubformGalleryArr(old_arr => {
                                  return js_utils.array_item_move_pure(old_arr, index, 1);
                                });
                              }}
                            />
                          </UniBtnPack>
                        </div>
                        {
                          true && (
                            <div>
                              <UniBtn
                                circle
                                size={16}
                                i="fa fa-trash"
                                themeCompoColorRed
                                extraClass="yourmap__theme__custom-btn-orange222"
                                handleClick={() => {
                                  setSubformGalleryArr(old_arr => {
                                    return old_arr.filter((item, i) => {
                                      if (i === index) {
                                        return false;
                                      }
                                      return true;
                                    });
                                  });
                                }}
                              />
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <UniImage src={src} extraClass="yourmap__theme__image-lib-figure" />
                  <div className="yourmap__image-library__admin-gallery__item__filename"><a target="_blank" rel="noopener noreferrer" href={src} >{img_filename}</a></div>
                </div>
              );
            })
          }
        </div>
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span>Pick gallery images </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload gallery Images"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 22,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickMultipleImages={cbPickMultipleImages}
                    enableSelectMultiple={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
    </>
  );
};


//
const WidegtImageWithSizePicker = (props) => {
  const {
    src,
    setState,
    state,
  } = props;
  //
  //
  const [sizePickerOpened, setSizePickerOpened] = useState(false);
  //
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [loading, setLoading] = useState(true);
  const imgRef = useRef(null);
  let original_aspect_ratio = 0;
  if (dimensions.width > 0 && dimensions.height > 0) {
    original_aspect_ratio = dimensions.width / dimensions.height;
  }

  // Funkcija koja se poziva kada se slika učita
  const handleLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    setDimensions({ width: naturalWidth, height: naturalHeight });
    setLoading(false);
  };

  useEffect(() => {
    // Provera da li je slika već učitana iz keša pre nego što se JS pokrenuo
    if (imgRef.current && imgRef.current.complete) {
      setDimensions({
        width: imgRef.current.naturalWidth,
        height: imgRef.current.naturalHeight
      });
      setLoading(false);
    }
  }, [src]);

  // -----
  const {
    smestaj_marker_img_w,
    smestaj_marker_img_h,
    smestaj_marker_img_anchor_left,
    smestaj_marker_img_anchor_top,
  } = state;
  let aspect_ratio = 0;
  if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0) {
    aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
  }
  let preview_img_w = 0;
  let preview_img_h = 0;
  if (smestaj_marker_img_w > 0) {
    preview_img_w = smestaj_marker_img_w;
  }
  if (smestaj_marker_img_h > 0) {
    preview_img_h = smestaj_marker_img_h;
  }
  //
  const handleClickPickAnchorPosition = (e) => {
    // Iako postoji i e.nativeEvent.offsetX, on može biti nepouzdan ako kliknete na dete (child) unutar glavnog elementa, jer će tada vratiti poziciju relativno u odnosu na to dete, a ne na roditelja.
    // 1. Dobijanje pozicije i veličine elementa u odnosu na vidljivi prozor (viewport)
    const rect = e.currentTarget.getBoundingClientRect();
    // 2. Oduzimanje pozicije elementa od apsolutne pozicije kursora (clientX/Y)
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    // console.log(`Relativna pozicija -> Levo: ${x}px, Gore: ${y}px`);
    if (x > 0 && y > 0) {
      setState(state => {
        return {
          ...state,
          // smestaj_marker_img_anchor_left: Math.round(x),
          // smestaj_marker_img_anchor_top: Math.round(y),
          smestaj_marker_img_anchor_left: Math.floor(x),
          smestaj_marker_img_anchor_top: Math.floor(y),
        }
      });
    }
  };

  if (sizePickerOpened === false) {
    return (
      <>
        <div>
          <div>
            <span>Marker dimensions </span>
            <UniBtn
              disabled={false}
              inline
              wide
              circle
              size={24}
              i="fa fa-magic"
              title_EX={"Pick marker dimensions"}
              title={"Marker dimensions helper"}
              handleClick={() => { setSizePickerOpened(true); }}
            />
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div>
          {/*<span>Pick marker dimensions </span>*/}
          <span>Marker dimensions helper: </span>
          {/*<UniBtn
            disabled={false}
            inline
            wide
            circle
            size={24}
            i="fa fa-magic"
            title={"Pick w:" + dimensions.width + " h:" + dimensions.height}
            handleClick={() => {
              setState(state => {
                if (js_utils.is_number(dimensions.width) && js_utils.is_number(dimensions.height)) {
                  return {
                    ...state,
                    smestaj_marker_img_w: dimensions.width,
                    smestaj_marker_img_h: dimensions.height,
                  };
                } else {
                  return state; // return unchanged
                }
              });
              setSizePickerOpened(false);
            }}
          /> */}
          <UniBtn
            disabled={false}
            inline
            wide
            outline
            circle
            size={24}
            i="fa fa-times"
            title_EX="Cancel"
            title="Zatvori"
            titleOnly
            handleClick={() => { setSizePickerOpened(false); }}
          />
        </div>
        <div className="uu-gap-standalone-4px"></div>
        <div className="yourmap__image-library__pick-dimensions">
          {/*preview:*/}
          {/*<UniImage src={preview_src} extraClass="yourmap__theme__image-lib-preview" />*/}
          <div>
            {loading ? <p>loading...</p> : (
              <div className="uu-text-left">
                <div><span className="yourmap__image-library__small">Detected <b>original resolution</b>:</span> <span className="uu-font-number">{dimensions.width} x {dimensions.height} px</span> <UniBtn
                  disabled={false}
                  inline
                  wide
                  circle
                  size={24}
                  i="fa fa-magic"
                  titleOnly
                  title={"Pick"}
                  handleClick={() => {
                    setState(state => {
                      if (js_utils.is_number(dimensions.width) && js_utils.is_number(dimensions.height)) {
                        return {
                          ...state,
                          smestaj_marker_img_w: dimensions.width,
                          smestaj_marker_img_h: dimensions.height,
                        };
                      } else {
                        return state; // return unchanged
                      }
                    });
                    // setSizePickerOpened(false);
                  }}
                /> </div>
                <div><span className="yourmap__image-library__small"><b>Original aspect ratio</b>:</span> <span className="uu-font-number">{original_aspect_ratio.toFixed(3)}</span></div>
                <div><span className="yourmap__image-library__small"><b>New dimensions</b>:</span> <span className="uu-font-number">{/*{'0'} x {'0'} px*/} </span> <UniBtn
                  inline
                  circle
                  size={24}
                  i="fa fa-compress"
                  handleClick={() => {
                    setState(state => {
                      const {
                        smestaj_marker_img_w,
                        smestaj_marker_img_h,
                      } = state;
                      if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                        const resized_h_raw = smestaj_marker_img_h * 0.97;
                        const resized_h = Math.round(resized_h_raw);
                        const resized_w = Math.round(resized_h_raw * aspect_ratio);
                        return {
                          ...state,
                          smestaj_marker_img_w: resized_w,
                          smestaj_marker_img_h: resized_h,
                        };
                      } else {
                        return state; // return unchanged
                      }
                    });
                  }}
                />&nbsp;<UniBtn
                    inline
                    circle
                    size={24}
                    i="fa fa-expand"
                    handleClick={() => {
                      setState(state => {
                        const {
                          smestaj_marker_img_w,
                          smestaj_marker_img_h,
                        } = state;
                        if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                          const aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
                          const resized_h_raw = smestaj_marker_img_h * 1.03;
                          const resized_h = Math.round(resized_h_raw);
                          const resized_w = Math.round(resized_h_raw * aspect_ratio);
                          return {
                            ...state,
                            smestaj_marker_img_w: resized_w,
                            smestaj_marker_img_h: resized_h,
                          };
                        } else {
                          return state; // return unchanged
                        }
                      });
                    }}
                  /> <span className="yourmap__image-library__small"><b>New aspect ratio</b>:</span> <span className="uu-font-number">{aspect_ratio.toFixed(3)}</span></div>
                {/*<div><span className="yourmap__image-library__small"><b>New anchor</b>:</span> <span className="uu-font-number">left:{'0'} top:{'0'}</span></div>*/}
                <div><span className="yourmap__image-library__small">Preview <b>new</b>:</span></div>
              </div>
            )}
          </div>
          <div className="uu-gap-standalone-05rem"></div>
          <div
            className="yourmap__image-library__pick-dimensions__img-container"
            style={{
              width: preview_img_w,
              height: preview_img_h
            }}
            onClick={handleClickPickAnchorPosition}
          >
            <img
              ref={imgRef}
              src={src}
              onLoad={handleLoad}
              alt="Preview"
              style={{
                // maxWidth: '100%', 
                // height: 'auto',
                width: preview_img_w,
                height: preview_img_h
              }}
            />
            <div className="yourmap__image-library__pick-dimensions__img-container_crosshair-left" style={{ left: smestaj_marker_img_anchor_left }}></div>
            <div className="yourmap__image-library__pick-dimensions__img-container_crosshair-top" style={{ top: smestaj_marker_img_anchor_top }}></div>
          </div>
        </div>
      </>
    );
  }
};


//
const PickMarkerPositionOnMap = (props) => {
  const {
    options,
  } = props;
  //
  const [hideAllMarkers, setHideAllMarkers] = useState(false);
  const [scaleMarkersTo1, setScaleMarkersTo1] = useState(false);
  let cl_map_extraClass = '';
  if (hideAllMarkers === true) {
    cl_map_extraClass += ' yourmap__map-special-filtering__hide-all-markers';
  }
  if (scaleMarkersTo1 === true) {
    cl_map_extraClass += ' yourmap__map-special-scale__scale-1-all-markers';
  }
  //
  return (
    <>
      <div className="unicompo-various-content">
        <h4 className="uu-mt-0">Pick position</h4>
        <div className="uu-vector uu-vector--row">
          <p>Click on any point and coordinates will be copied to form automatically</p>
          <div className="uu-gap-standalone-1rem"></div>
          <FormFieldGenerator
            fieldDefinition={{
              "type": "input_checkbox",
              "params": {
                "label": "Sakrij sve markere",
                "name": "hideAllMarkers"
              }
            }}
            value={hideAllMarkers}
            handleChange={(e) => {
              setHideAllMarkers(state => !state); // toggle
            }}
            fieldError={null}
          />
          <div className="uu-gap-standalone-1rem"></div>
          <FormFieldGenerator
            fieldDefinition={{
              "type": "input_checkbox",
              "params": {
                "label": "Markers scale 1:1",
                "name": "scaleMarkersTo1"
              }
            }}
            value={scaleMarkersTo1}
            handleChange={(e) => {
              setScaleMarkersTo1(state => !state); // toggle
            }}
            fieldError={null}
          />
        </div>
        <div className="yourmap__map-pos-picker">
          <div className={"yourmap__map" + cl_map_extraClass}>
            <YourmapMapPageWrapper
              mapFetching={false}
            >
              <YourmapLeafletContainerUniversal ll={[51.2, -159.6]} options={options} />
            </YourmapMapPageWrapper>
          </div>
        </div>
      </div>
    </>
  );
};
//
const FormPartMarker = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage_2,
    // subformGalleryArr,
    // setSubformGalleryArr,
    options,
  } = formPart_pack;
  //
  const {
    smestaj_marker_img_w,
    smestaj_marker_img_h,
  } = state;
  let aspect_ratio = 0;
  if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0) {
    aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
  }
  //
  let src = '';
  const img_url_full = _zzyourmap_img_url_full_from_parts(state?.smestaj_marker_img_filename, state?.smestaj_marker_img_folder);
  if (typeof img_url_full === 'string') {
    src = img_url_full;
  }
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_marker()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
        <div className="uu-gap-standalone-05rem"></div>
        <div>
          <span>Pick marker image </span>
          <UniBtn
            inline
            wide
            circle
            size={24}
            i="fa fa-picture-o"
            title="Pick/Upload Image"
            handleClick={() => {
              setUniModalPortableContent_2({
                options: {
                  large: true,
                  zIndex: 22,
                },
                jsx: (
                  <>
                    <YourmapImageLibraryV4
                      appPack={props.appPack}
                      cbDialogCancel={setUniModalPortableClose_2}
                      cbPickSingleImage={cbPickSingleImage_2}
                      enableSelectSingular={true}
                    />
                  </>
                ),
              });
            }}
          />
        </div>
        <div className="uu-gap-standalone-05rem"></div>
        <WidegtImageWithSizePicker src={src} setState={setState} state={state} />
        <div className="uu-gap-standalone-05rem"></div>
        <div>
          <span>Pick marker position </span>
          <UniBtn
            disabled={false}
            inline
            wide
            circle
            size={24}
            i="fa fa-map-marker"
            title="Pick marker position"
            handleClick={() => {
              // ++++
              setUniModalPortableContent_2({
                options: {
                  large: true,
                  zIndex: 22,
                },
                jsx: (
                  <PickMarkerPositionOnMap options={options} />
                ),
              });
            }}
          />
        </div>
        <div className="uu-gap-standalone-05rem"></div>
        {/*
        <div><span>* Uvećaj/Smanji marker ali pamti marker aspect ratio pa koriguj: {aspect_ratio.toFixed(3)} </span>
          <UniBtn
            inline
            circle
            size={24}
            i="fa fa-compress"
            handleClick={() => {
              setState(state => {
                const {
                  smestaj_marker_img_w,
                  smestaj_marker_img_h,
                } = state;
                if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                  const resized_h_raw = smestaj_marker_img_h * 0.97;
                  const resized_h = Math.round(resized_h_raw);
                  const resized_w = Math.round(resized_h_raw * aspect_ratio);
                  return {
                    ...state,
                    smestaj_marker_img_w: resized_w,
                    smestaj_marker_img_h: resized_h,
                  };
                } else {
                  return state; // return unchanged
                }
              });
            }}
          />&nbsp;<UniBtn
            inline
            circle
            size={24}
            i="fa fa-expand"
            handleClick={() => {
              setState(state => {
                const {
                  smestaj_marker_img_w,
                  smestaj_marker_img_h,
                } = state;
                if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                  const aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
                  const resized_h_raw = smestaj_marker_img_h * 1.03;
                  const resized_h = Math.round(resized_h_raw);
                  const resized_w = Math.round(resized_h_raw * aspect_ratio);
                  return {
                    ...state,
                    smestaj_marker_img_w: resized_w,
                    smestaj_marker_img_h: resized_h,
                  };
                } else {
                  return state; // return unchanged
                }
              });
            }}
          />
        </div>
        */}
      </div>
    </>
  );
};


// DJUTURE
const YourmapFormYmthing = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  const {
    destination_entities_adm,
    options_adm_parent_of_destination,
    options_adm_parent_of_smestaj,
    layer_titles_all,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;
  //
  let initialState;
  let formDefinition;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
    // formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ... _zzyourmap_formDefinition_smestaj(options_adm_parent_of_smestaj)];
  } else {
    initialState = { ..._zzyourmap_preset_smestaj() };
    // formDefinition = _zzyourmap_formDefinition_smestaj(state, options_adm_parent_of_smestaj);
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  const [subformGalleryArr, setSubformGalleryArr] = useState(js_utils.fix_always_arr(initialState?.gallery_img_arr));
  if (editMode) {
    formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_smestaj(state, options_adm_parent_of_smestaj, layer_titles_all)];
  } else {
    formDefinition = _zzyourmap_formDefinition_smestaj(state, options_adm_parent_of_smestaj, layer_titles_all);
  }
  //
  const cbPickSingleImage = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        smestaj_main_img_filename: img_filename,
        smestaj_main_img_folder: img_folder,
      };
    });
  };
  const cbPickSingleImage_2 = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK 2', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        smestaj_marker_img_filename: img_filename,
        smestaj_marker_img_folder: img_folder,
      };
    });
  };
  const cbPickMultipleImages = (bingo_items_arr, imglib_item_key, img_url) => {
    console.log('* * * * * PICK 3', bingo_items_arr);
    let updatedSubformArr = [];
    bingo_items_arr.forEach((imglib_item) => {
      let img_filename = null;
      let img_folder = null;
      if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
        img_filename = imglib_item?.img_filename;
        if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
          img_folder = imglib_item?.img_folder;
        }
      }
      //
      if (img_filename) {
        updatedSubformArr.push(img_filename);
      }
    });
    console.log('updatedSubformArr', updatedSubformArr);
    setSubformGalleryArr(sub_arr => {
      // return updatedSubformArr;
      return [...sub_arr, ...updatedSubformArr];
    });
  };
  //
  const _cbClickLatLng = (bottom, left) => {
    console.log('_cbClickLatLng', bottom, left, typeof bottom, typeof left);
    setState(state => {
      return {
        ...state,
        smestaj_marker_img_bottom: Number.parseInt(bottom),
        smestaj_marker_img_left: Number.parseInt(left),
      };
    });
  };
  let options = {
    ..._zzyourmap_extract_map_props_1_for_smestaj_position_picker(state, destination_entities_adm),
    enableClickLatLng: true, // enable pick lat lng coordinates
    _cbClickLatLng,
    // markers_arr: [],
  };
  //
  const formPart_pack = {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    setSubformGalleryArr,
    options,
  };
  //
  return (
    <div className="unicompo-various-content yourmap-theme__scope-admin-panel">
      <h3 className="uu-mt-0">{editMode ? ('Izmeni ymthing') : ('Dodaj novi ymthing')}</h3>
      <div>
        <FormGenerator
          formDefinition={formDefinition}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      {/* formPart KONTAKT */}
      <FormPartKontakt appPack={props.appPack} formPart_pack={formPart_pack} />
      {/* formPart CHECKS */}
      <FormPartChecks appPack={props.appPack} formPart_pack={formPart_pack} />
      {/* formPart MAIN IMAGE */}
      <FormPartMainImg appPack={props.appPack} formPart_pack={formPart_pack} />
      {/* formPart GALLERY */}
      <FormPartGallery appPack={props.appPack} formPart_pack={formPart_pack} />
      {/* formPart MARKER */}
      <FormPartMarker appPack={props.appPack} formPart_pack={formPart_pack} />
      <div className="uu-gap-standalone-1rem"></div>
      <div className="uu-gap-standalone-1rem"></div>
      <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
        <UniBtn
          disabled={false}
          inline
          wide
          circle_EX
          i="fa fa-paper-plane"
          title="Submit"
          handleClick={() => {
            // cbDialogSubmit(state);
            const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_smestaj(state, subformGalleryArr);
            if (editMode) { // EDIT
              const payload = { of_id: state.of_id };
              cbDialogSubmit(prepared_entbox, payload);
            } else { // ADD
              cbDialogSubmit(prepared_entbox);
            }
            // cbDialogCancel();
          }}
        />
        <UniBtn
          disabled={false}
          inline
          wide
          outline
          circle_EX
          i="fa fa-times"
          title="Cancel"
          handleClick={() => { cbDialogCancel(); }}
        />
      </div>
      <div className="uu-gap-standalone-1rem"></div>
    </div>
  );
};


// BLOG (ostalo_v1)
const YourmapFormYmostaloV1 = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  const {
    destination_entities_adm,
    options_adm_parent_of_destination,
    options_adm_parent_of_smestaj,
    layer_titles_all,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;
  let _show_blog_post_editor = false;
  //
  let initialState;
  let formDefinition;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
    // formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_ostalo_v1(state, options_adm_parent_of_smestaj)];
  } else {
    initialState = { ..._zzyourmap_preset_ostalo_v1() };
    // formDefinition = _zzyourmap_formDefinition_ostalo_v1(state, options_adm_parent_of_smestaj);
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  if (editMode) {
    formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_ostalo_v1(state, options_adm_parent_of_smestaj, layer_titles_all)];
  } else {
    formDefinition = _zzyourmap_formDefinition_ostalo_v1(state, options_adm_parent_of_smestaj, layer_titles_all);
  }

  // const [subformGalleryArr, setSubformGalleryArr] = useState(js_utils.fix_always_arr(initialState?.gallery_img_arr));
  //
  const cbPickSingleImage = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        smestaj_main_img_filename: img_filename,
        smestaj_main_img_folder: img_folder,
      };
    });
  };
  const cbPickSingleImage_2 = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK 2', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        smestaj_marker_img_filename: img_filename,
        smestaj_marker_img_folder: img_folder,
      };
    });
  };
  /*
  const cbPickMultipleImages = (bingo_items_arr, imglib_item_key, img_url) => {
          console.log('* * * * * PICK 3', bingo_items_arr);
        let updatedSubformArr = [];
    bingo_items_arr.forEach((imglib_item) => {
          let img_filename = null;
        let img_folder = null;
        if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
          img_filename = imglib_item?.img_filename;
        if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
          img_folder = imglib_item?.img_folder;
        }
      }
        //
        if (img_filename) {
          updatedSubformArr.push(img_filename);
      }
    });
        console.log('updatedSubformArr', updatedSubformArr);
    setSubformGalleryArr(sub_arr => {
      return updatedSubformArr;
    });
  };
        */
  //
  const _cbClickLatLng = (bottom, left) => {
    console.log('_cbClickLatLng', bottom, left, typeof bottom, typeof left);
    setState(state => {
      return {
        ...state,
        smestaj_marker_img_bottom: Number.parseInt(bottom),
        smestaj_marker_img_left: Number.parseInt(left),
      };
    });
  };
  let options = {
    ..._zzyourmap_extract_map_props_1_for_smestaj_position_picker(state, destination_entities_adm),
    enableClickLatLng: true, // enable pick lat lng coordinates
    _cbClickLatLng,
    // markers_arr: [],
  };
  //
  const formPart_pack = {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage_2,
    options,
  };
  //
  if (state.smestaj_tab === "NONE") {
    _show_blog_post_editor = false;
  } else {
  }
  // if (Easy69_v1.is_value_in_array(state.smestaj_tab, ["SERVISI", "OSTALO"])) {
  if (Easy69_v1.is_value_in_array(state.smestaj_tab, ["blog"])) {
    _show_blog_post_editor = true;
  } else {
    _show_blog_post_editor = false;
  }
  //
  const _special_blog_post_data = state._special_blog_post_data; // TODO
  let editorjs_renderable_data = _zzyourmap_extract_editorjs_renderable_data(_special_blog_post_data);
  //
  return (
    <div className="unicompo-various-content yourmap-theme__scope-admin-panel">
      <h3 className="uu-mt-0">{editMode ? ('Izmeni * OSTALO v1') : ('Dodaj novi * OSTALO v1')}</h3>
      <UniLimiter w={300}>
        <Komentar>
          <p>- Treba razmisliti koji treba da budu nazivi "tabova", "layera" (legende)</p>
          <p>- Treba razmisliti da li da ove stvari mogu da pripadaju samo destinaciji bez specificiranja poddestinacije?</p>
        </Komentar>
      </UniLimiter>
      <HelpWidget>
        <p>- Polje "smestaj_podnalov" je u stvari kratak opis (rečenica) koji se prikazuje na karticama od smeštaja, restorana i ostalog...</p>
        <p>- Polje "smestaj_opis" je malo duži opis (2-3 rečenice) koji se prikazuju u popup-u kada se klikne na marker. Kada je u pitanju blog post, to bi trebalo da se unese "teaser" tekst tj. prve 2-3 rečenice od blog posta.</p>
        <p>- U slučaju kada je "smestaj_opis" izabrano "NONE" onda nema blog posta (ima samo marker), moguće je popuniti samo osnovna polja.</p>
        <p>- U blog editoru, slika se dodaje tako što, negde nadjete kompletan url do slike koja je već na internetu (najbolje u Image Library), zatim uradite <b>Copy</b> pa zatim u blog editoru u novi red uradite <b>Paste</b>. Ako je slika u podržanom formatu blog editor će je sam prepoznati i tretirati kao sliku.</p>
      </HelpWidget>
      <div>
        <FormGenerator
          formDefinition={formDefinition}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span>Pick main image </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload Image"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 22,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickSingleImage={cbPickSingleImage}
                    enableSelectSingular={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      {/*
        state.smestaj_marker_enabled === true && (
          <>
            <div><span>* Uvećaj/Smanji marker ali pamti marker aspect ratio pa koriguj: {aspect_ratio.toFixed(3)} </span>
              <UniBtn
                inline
                circle
                size={24}
                i="fa fa-compress"
                handleClick={() => {
                  setState(state => {
                    const {
                      smestaj_marker_img_w,
                      smestaj_marker_img_h,
                    } = state;
                    if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                      const resized_h_raw = smestaj_marker_img_h * 0.97;
                      const resized_h = Math.round(resized_h_raw);
                      const resized_w = Math.round(resized_h_raw * aspect_ratio);
                      return {
                        ...state,
                        smestaj_marker_img_w: resized_w,
                        smestaj_marker_img_h: resized_h,
                      };
                    } else {
                      return state; // return unchanged
                    }
                  });
                }}
              />&nbsp;<UniBtn
                inline
                circle
                size={24}
                i="fa fa-expand"
                handleClick={() => {
                  setState(state => {
                    const {
                      smestaj_marker_img_w,
                      smestaj_marker_img_h,
                    } = state;
                    if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                      const aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
                      const resized_h_raw = smestaj_marker_img_h * 1.03;
                      const resized_h = Math.round(resized_h_raw);
                      const resized_w = Math.round(resized_h_raw * aspect_ratio);
                      return {
                        ...state,
                        smestaj_marker_img_w: resized_w,
                        smestaj_marker_img_h: resized_h,
                      };
                    } else {
                      return state; // return unchanged
                    }
                  });
                }}
              />
            </div>
            <div className="uu-gap-standalone-05rem"></div>
            <div>
              <span>Pick marker image </span>
              <UniBtn
                inline
                wide
                circle
                size={24}
                i="fa fa-picture-o"
                title="Pick/Upload Image"
                handleClick={() => {
                  setUniModalPortableContent_2({
                    options: {
                      large: true,
                      zIndex: 22,
                    },
                    jsx: (
                      <>
                        <YourmapImageLibraryV4
                          appPack={props.appPack}
                          cbDialogCancel={setUniModalPortableClose_2}
                          cbPickSingleImage={cbPickSingleImage_2}
                          enableSelectSingular={true}
                        />
                      </>
                    ),
                  });
                }}
              />
            </div>
            <div className="uu-gap-standalone-05rem"></div>
            <div>
              <span>Pick marker position </span>
              <UniBtn
                disabled={false}
                inline
                wide
                circle
                size={24}
                i="fa fa-map-marker"
                title="Pick marker position"
                handleClick={() => {
                  // ++++
                  setUniModalPortableContent_2({
                    options: {
                      large: true,
                      zIndex: 22,
                    },
                    jsx: (
                      <div className="unicompo-various-content">
                        <h4 className="uu-mt-0">Pick position</h4>
                        <p>Click on any point and coordinates will be copied to form automatically</p>
                        <div className="yourmap__map-pos-picker">
                          <div className="yourmap__map">
                            <YourmapMapPageWrapper
                              mapFetching={false}
                            >
                              <YourmapLeafletContainerUniversal ll={[51.2, -159.6]} options={options} />
                            </YourmapMapPageWrapper>
                          </div>
                        </div>
                      </div>
                    ),
                  });
                }}
              />
            </div>
            <div className="uu-gap-standalone-05rem"></div>
            <div>
              <span><a target="_blank" rel="noopener noreferrer" href="https://www.openstreetmap.org/?#map=17/43.285457/20.809350">* Find Geo URI here</a></span>
            </div>
            <div className="uu-gap-standalone-05rem"></div>
          </>
        )
      */}
      {
        state.smestaj_marker_enabled === true && (
          <>
            {/* formPart MARKER */}
            <FormPartMarker appPack={props.appPack} formPart_pack={formPart_pack} />
          </>
        )
      }
      <div>
        {/* <span>Pick gallery images </span> */}
      </div>
      <div className="uu-gap-standalone-1rem"></div>
      {
        _show_blog_post_editor === true && (
          <>
            <FormGenerator
              formDefinition={[
                {
                  "type": "separator",
                },
                {
                  "type": "html_tag_text",
                  "params": {
                    "title": "Blog post",
                    "tag": "h4",
                    "extraclass": "yourmap__form-part-heading"
                  }
                },
              ]}
              formState={{}}
              formErrors={{}}
              handleChange={() => { }}
            />
            <div className="uu-gap-standalone-1rem"></div>
            <CardCollapsible small jsxHeader={<h4>Blog post EDITOR</h4>}>
              {/*<UniSpinnerClassic />*/}
              <YourmapEditorjsV2
                editorjsState={editorjs_renderable_data}
                setEditorjsState={(updatedEditorjsRenderableData) => {
                  setState(state => {
                    return {
                      ...state,
                      /*
                      _special_blog_post_data: {
                        is_editorjs: true,
                        editorjs_data: updatedEditorjsRenderableData,
                      },
                      */
                      _special_blog_post_data: _zzyourmap_update_special_blog_post_data(state._special_blog_post_data, updatedEditorjsRenderableData),
                    };
                  })
                }}
              />
            </CardCollapsible>
            <CardCollapsible small jsxHeader={'Blog post * DEBUG'}>
              <JSDisplayValue val={editorjs_renderable_data} />
            </CardCollapsible>
            <CardCollapsible small jsxHeader={<h4>Blog post PREVIEW</h4>}>
              <>
                <FrfrAlienEditorjsRendererV1 editorjs_renderable_data={editorjs_renderable_data} />
              </>
            </CardCollapsible>
            <div className="uu-gap-standalone-1rem"></div>
          </>
        )
      }
      <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
        <UniBtn
          disabled_NOT={(Easy69_v1.is_value_in_array(state.smestaj_tab, ["SERVISI", "OSTALO", "NONE"]) ? false : true)}
          disabled={(typeof state.smestaj_tab === 'string' ? false : true)}
          inline
          wide
          circle_EX
          i="fa fa-paper-plane"
          title="Submit"
          handleClick={() => {
            // cbDialogSubmit(state);
            const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_ostalo_v1(state, {});
            if (editMode) { // EDIT
              const payload = { of_id: state.of_id };
              cbDialogSubmit(prepared_entbox, payload);
            } else { // ADD
              cbDialogSubmit(prepared_entbox);
            }
            // cbDialogCancel();
          }}
        />
        <UniBtn
          disabled={false}
          inline
          wide
          outline
          circle_EX
          i="fa fa-times"
          title="Cancel"
          handleClick={() => { cbDialogCancel(); }}
        />
      </div>
      <div className="uu-gap-standalone-1rem"></div>
    </div>
  );
};


//
const YourmapAdminDestinationList = (props) => {
  /*
        const {
        } = props;
        */
  const {
    appState,
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent,
    setUniModalPortableClose,

    fetchGetAll,
    tempArr,
    dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    current_smestaj_entity,
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    smestaj_entities,
    smestaj_entities_fetching,
    smestaj_entities_adm,
  } = props.appPack;

  const _test_fetch_create = () => {
    //
    const vr_tablename = 'proba_tablename2';
    const test_data = {
      thisis: 'test_data',
      something: 123,
      other: 'abc',
    };
    const data_json = json_utils.js_to_always_json(test_data);
    const data = {
      vr_tablename,
      data_json,
      note: 'proba_note',
    }
    //
    _zzyourmap_ajax.create(data, vr_tablename)
      .then(response => {
        console.log('response', response);

      })
      .catch(err => {
        console.log('CATCH ERROR in _test_fetch_create', err);
      })
  };

  return (
    <>
      <div className="yourmap__admin-panel">

        <section>
          <div className="inner-admin-panel">

            {/*
            <div>
              <Btn
                disabled={false}
                title={'TEST CREATE'}
                btnColor={'btn--color-mui-indigo'}
                btnSmallWithTitle
                inline
                i='fa fa-pencil'
                tooltip='TEST CREATE'
                handleClick={() => {
                  //
                  // TEST
                  _test_fetch_create();
                }}
              />
              <Btn
                disabled={false}
                title={'TEST GET ALL'}
                btnColor={'btn--color-mui-indigo'}
                btnSmallWithTitle
                inline
                i='fa fa-pencil'
                tooltip='TEST GET ALL'
                handleClick={() => {
                  //
                  // TEST
                  fetchGetAll();
                }}
              />
            </div>
            */}
            {/*
            <h1>YourmapAdminDestinationList destinacije</h1>
            */}

            <ViewGeneratorSimpleV4
              route_freshness={route_freshness}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: (entbox) => {
                  window.alert('*** (Sumbit CREATE entity) ***');
                },
              }}
              viewDefinition={{
                view_key: 'YourmapAdminDestinationList',
                // table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                table_additional_column_keys_EX: ["destinacija_tip", "parent_destinacija_id", "destinacija_slug", "destinacija_naslov", "destinacija_poddestinacija_naslov", "_main_img_url", "komentar", "_data_digest_valid"],
                table_additional_column_keys: [
                  {
                    key: "destinacija_tip",
                    title: "Tip",
                    minWidth: 128,
                  },
                  "parent_destinacija_id",
                  {
                    key: "destinacija_slug",
                    title: "Slug"
                  },
                  {
                    key: "destinacija_naslov",
                    title: "Naslov"
                  },
                  "destinacija_poddestinacija_naslov",
                  {
                    key: "_main_img_url",
                    title: "Main img."
                  },
                  "komentar", "_data_digest_valid"],
                cbEntityKeyExtractor: (entity, index) => {
                  // console.log('cbEntityKeyExtractor', entity);
                  // return entity.id;
                  return entity.of_id;
                },
                options: {
                  entity_col_disabled: false,
                },
                cbSubmitCreate: (entbox) => {
                  console.log('SUBMIT entbox', entbox);
                  const vr_tablename = 'ym_table_destination';
                  const data_for_json = {
                    ...entbox,
                  };
                  const data_json = json_utils.js_to_always_json(data_for_json);
                  const entbox_j = {
                    // vr_tablename,
                    data_json,
                    note: 'proba_note ym_table_destination',
                  };
                  console.log('entbox_j', entbox_j);
                  _zzyourmap_ajax.create(entbox_j, vr_tablename)
                    .then(response => {
                      console.log('response', response);
                      if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                        const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                        //
                        console.log('succes res_payload', res_payload);
                        // REFRESH
                        fetchGetAll();
                        // CLOSE MODAL
                        setUniModalPortableClose();
                      }
                    })
                    .catch(err => {
                      console.error('ERROR cbSubmitCreate ym_table_destination', err);
                    });

                },
                cbModalCreate: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormDestination
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity, payload) => {
                  // return JSX action buttons
                  return (
                    <>
                      <div className="uu-text-wrap uu-gaps-m-05rem">
                        <UniBtn
                          disabled={false}
                          inline
                          wide
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'Edit'}
                          tooltip='Edit entity'
                          btnColor_TODO={'btn--color-mui-indigo'}
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <>
                                  <YourmapFormDestination
                                    cbDialogSubmit={(entbox, payload) => {
                                      console.log('SUBMIT UPDATE entbox', entbox, payload);
                                      const vr_tablename = 'ym_table_destination';
                                      const data_for_json = {
                                        ...entbox,
                                      };
                                      const data_json = json_utils.js_to_always_json(data_for_json);
                                      const entbox_j = {
                                        // vr_tablename,
                                        data_json,
                                        note: 'proba_note ym_table_destination',
                                      };
                                      console.log('entbox_j', entbox_j);
                                      const of_id = payload.of_id;
                                      _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                        .then(response => {
                                          console.log('response', response);
                                          if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                            const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                            //
                                            console.log('succes res_payload', res_payload);
                                            // REFRESH
                                            fetchGetAll();
                                            // CLOSE MODAL
                                            setUniModalPortableClose();
                                          }
                                        })
                                        .catch(err => {
                                          console.error('ERROR cbSubmitCreate ym_table_destination', err);
                                        });

                                      ////
                                    }}
                                    cbDialogCancel={setUniModalPortableClose}
                                    appPack={props.appPack}

                                    mode={'EDIT'}
                                    editorData={{ ...entity }}
                                  /*
                                    jsxHeader={<h2 className="heading-on-top">Edit client</h2>}
                                    initialState={{ ...entity }}
                                    formDefinition={_zzsurvey_formDefinitionClient}
                                    fetchingSubmit={appState.fetchingSubmit}
                                    cbSubmit={(entbox) => {
                                      const _entbox = entbox;
                                      if (typeof entbox.email === 'string') {
                                        _entbox.email = entbox.email.trim().toLowerCase();
                                      }
                                      fetchUpdateUniversal(TABLE_CLIENTS, _entbox)
                                    }}
                                    cbCancel={() => { setModalPortableContent(false); }}
                                    */
                                  />
                                </>
                              ),
                            });
                          }}
                        />
                        <UniBtn
                          disabled={entity?._master_flag_deleted === true ? true : false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-toggle-off'
                          title={'Deactivate'}
                          iconOnly
                          tooltip='Deactivate SOFT'
                          themeCompoColorRed
                          btnColor_TODO={'btn--color-mui-indigo'}
                          btnColor={'btn--red'}
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da deaktivirate entity?")) {
                              // TODO
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_flagdeleted({ flag_deleted: true }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_flagdeleted successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_flagdeleted:', err);
                                });

                            }
                          }}
                        />
                        <UniBtn
                          disabled={entity?._master_flag_deleted === true ? false : true}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-toggle-on'
                          title={'Activate'}
                          iconOnly
                          tooltip='Activate SOFT'
                          themeCompoColorRed
                          btnColor_TODO={'btn--color-mui-indigo'}
                          btnColor={'btn--red'}
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da aktivirate entity?")) {
                              // TODO
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_undelete({ flag_deleted: false }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_undelete successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_undelete:', err);
                                });

                            }
                          }}
                        />
                        {/*
                        <Btn
                          disabled={entity.is_active === false}
                          title={'Deactivate HARD'}
                          btnColor={'btn--red'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-trash'
                          tooltip='Deactivate client'
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da obrišete klijenta?")) {
                              // TODO
                              // crudDeleteUniversal();

                            }
                          }}
                        />
                        */}
                      </div>
                    </>
                  );
                },

              }}
              viewArr_EX={'dmd_utils_prepare_smart({}).arr'}
              fetching_EX={true}
              viewArr_EX2={tempArr}
              viewArr_EX3={dmd_utils.dmd_to_always_arr(dmd_multitable_entities)}
              fetching_EX3={dmd_utils.is_fetching(dmd_multitable_entities)}
              viewArr={destination_entities_adm}
              fetching={destination_entities_fetching}
              jsxSpinner_OLD={'<UniSpinnerClassic />'}
            />

          </div>
        </section>
      </div>
    </>
  );
};


// DJUTURE
const YourmapAdminYmthingList = (props) => {
  /*
  const {
  } = props;
  */
  const {
    appState,
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent,
    setUniModalPortableClose,

    options_adm_parent_of_smestaj,

    fetchGetAll,
    dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    current_smestaj_entity,
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    ymthing_entities,
    ymthing_entities_fetching,
    ymthing_entities_adm,
    restoran_entities,
    restoran_entities_fetching,
    restoran_entities_adm,
  } = props.appPack;
  console.log('---------ymthing_entities_adm before filtering', ymthing_entities_adm);
  //
  const [state, handleChange, setState] = useHandleInputChange({ vr_tablename: '', parent_destinacija_id: '' }); // filter state
  //
  const ymthing_filtered_arr_1 = ymthing_entities_adm.filter((item) => {
    if (state.vr_tablename === '') {
      return true;
    } else {
      if (state.vr_tablename === item.vr_tablename) {
        return true;
      }
    }
    return false;
  });
  //
  const ymthing_filtered_arr = ymthing_filtered_arr_1.filter((item) => {
    if (state.parent_destinacija_id === '' || !state.parent_destinacija_id) {
      return true;
    } else {
      if (state.parent_destinacija_id === item.parent_destinacija_id) {
        return true;
      }
    }
    return false;
  });
  //
  return (
    <>
      <div className="yourmap__admin-panel">

        <section>
          <div className="inner-admin-panel">
            {/* PREFILTER */}
            <div className="uu-form-vector-row IZMENIME">
              <div className="uu-w-max-content">
                <form onSubmit={(e) => { e.preventDefault(); }}>
                  <FormGenerator
                    formDefinition={_zzyourmap_formDefinition_smestaj_formPart_parent_destinacija_id(options_adm_parent_of_smestaj)}
                    formState={state}
                    formErrors={{}}
                    handleChange={handleChange}
                  />
                </form>
              </div>
            </div>
            {/* PREFILTER */}
            <div className="uu-form-vector-row IZMENIME">
              <div className="uu-w-max-content">
                <form onSubmit={(e) => { e.preventDefault(); }}>
                  <FormGenerator
                    formDefinition={_zzyourmap_formDefinition_ymthing_prefilter_vr_tablename}
                    formState={state}
                    formErrors={{}}
                    handleChange={handleChange}
                  />
                </form>
              </div>
            </div>
            <ViewGeneratorSimpleV4
              route_freshness={route_freshness}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: (entbox) => {
                  window.alert('*** (Sumbit CREATE entity) ***');
                },
              }}
              viewDefinition={{
                view_key: 'TABLE_YMTHING',
                // table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                table_additional_column_keys_EX: ["vr_tablename", "parent_destinacija_id", "smestaj_naslov", "smestaj_marker_enabled", "_main_img_url", "websajt", "komentar ", "_data_digest_valid"],
                table_additional_column_keys: [
                  "vr_tablename",
                  "parent_destinacija_id",

                  {
                    key: "smestaj_tab",
                    title: "Tab",
                    minWidth: 96,
                  },
                  {
                    key: "_routing_tab",
                    title: "_tab.",
                    minWidth: 96,
                  },
                  {
                    key: "_marker_layer_title",
                    title: "_layer.",
                    minWidth: 96,
                  },
                  {
                    key: "smestaj_layer",
                    title: "Layer",
                    minWidth: 96,
                  },

                  {
                    key: "smestaj_naslov",
                    title: "Naslov",
                  },
                  {
                    key: "smestaj_marker_enabled",
                    title: "Marker",
                    minWidth: 80,
                  },
                  {
                    key: "_main_img_url",
                    title: "Main img.",
                  },
                  "websajt", "komentar ", "_data_digest_valid"],
                cbEntityKeyExtractor: (entity, index) => {
                  // console.log('cbEntityKeyExtractor', entity);
                  // return entity.id;
                  return entity.of_id;
                },
                options: {
                  entity_col_disabled: false,
                },
                cbSubmitCreate: (entbox) => {
                  console.log('SUBMIT entbox', entbox);
                  // const vr_tablename = 'ym_table_restoran';
                  const vr_tablename = entbox.vr_tablename;
                  const data_for_json = {
                    ...entbox,
                  };
                  delete data_for_json.vr_tablename; // TODO
                  const data_json = json_utils.js_to_always_json(data_for_json);
                  const entbox_j = {
                    // vr_tablename,
                    data_json,
                    note: 'proba_note ym_table_restoran',
                  };
                  console.log('entbox_j', entbox_j);
                  _zzyourmap_ajax.create(entbox_j, vr_tablename)
                    .then(response => {
                      console.log('response', response);
                      if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                        const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                        //
                        console.log('succes res_payload', res_payload);
                        // REFRESH
                        fetchGetAll();
                        // CLOSE MODAL
                        setUniModalPortableClose();
                      }
                    })
                    .catch(err => {
                      console.error('ERROR cbSubmitCreate ym_table_restoran DJUTURE', err);
                    });

                },
                cbModalCreate: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormYmthing
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity, payload) => {
                  // return JSX action buttons
                  return (
                    <>
                      <div className="uu-text-wrap uu-gaps-m-05rem">
                        <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'Edit'}
                          iconOnly
                          tooltip='Edit entity'
                          btnColor_TODO={'btn--color-mui-indigo'}
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormYmthing
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT UPDATE entbox', entbox, payload);
                                    // const vr_tablename = 'ym_table_restoran';
                                    const vr_tablename = entbox.vr_tablename;
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    delete data_for_json.vr_tablename; // TODO
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      // vr_tablename,
                                      data_json,
                                      note: 'proba_note ym_table_restoran *',
                                    };
                                    console.log('entbox_j', entbox_j);
                                    const of_id = payload.of_id;
                                    _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                      .then(response => {
                                        console.log('response', response);
                                        if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          //
                                          console.log('succes res_payload', res_payload);
                                          // REFRESH
                                          fetchGetAll();
                                          // CLOSE MODAL
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitCreate ym_table_restoran *', err);
                                      });

                                    ////
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}

                                  mode={'EDIT'}
                                  editorData={{ ...entity }}
                                />),
                            });
                          }}
                        />
                        <UniBtn
                          disabled={entity?._master_flag_deleted === true ? true : false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-toggle-off'
                          title={'Deactivate'}
                          iconOnly
                          tooltip='Deactivate SOFT'
                          themeCompoColorRed
                          btnColor_TODO={'btn--color-mui-indigo'}
                          btnColor={'btn--red'}
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da deaktivirate entity?")) {
                              // TODO
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_flagdeleted({ flag_deleted: true }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_flagdeleted successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_flagdeleted:', err);
                                });

                            }
                          }}
                        />
                        <UniBtn
                          disabled={entity?._master_flag_deleted === true ? false : true}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-toggle-on'
                          title={'Activate'}
                          iconOnly
                          tooltip='Activate SOFT'
                          themeCompoColorRed
                          btnColor_TODO={'btn--color-mui-indigo'}
                          btnColor={'btn--red'}
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da aktivirate entity?")) {
                              // TODO
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_undelete({ flag_deleted: false }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_undelete successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_undelete:', err);
                                });

                            }
                          }}
                        />
                      </div>
                    </>
                  );
                },

              }}
              viewArr={ymthing_filtered_arr}
              fetching={ymthing_entities_fetching}
            />

          </div>
        </section>
      </div>
    </>
  );
};


// BLOG (ostalo_v1)
const YourmapAdminYmostaloV1List = (props) => {
  /*
  const {
  } = props;
  */
  const {
    appState,
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent,
    setUniModalPortableClose,

    options_adm_parent_of_smestaj,

    fetchGetAll,
    dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    current_smestaj_entity,
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    restoran_entities,
    restoran_entities_fetching,
    restoran_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_fetching,
    ymostalo_v1_entities_adm,
  } = props.appPack;

  //
  const [state, handleChange, setState] = useHandleInputChange({ vr_tablename: '', parent_destinacija_id: '' }); // filter state
  //
  const ymostalo_v1_filtered_arr = ymostalo_v1_entities_adm.filter((item) => {
    if (state.parent_destinacija_id === '' || !state.parent_destinacija_id) {
      return true;
    } else {
      if (state.parent_destinacija_id === item.parent_destinacija_id) {
        return true;
      }
    }
    return false;
  });
  //
  return (
    <>
      <div className="yourmap__admin-panel">

        <section>
          <div className="inner-admin-panel">
            {/* PREFILTER */}
            <div className="uu-form-vector-row IZMENIME">
              <div className="uu-w-max-content">
                <form onSubmit={(e) => { e.preventDefault(); }}>
                  <FormGenerator
                    formDefinition={_zzyourmap_formDefinition_smestaj_formPart_parent_destinacija_id(options_adm_parent_of_smestaj)}
                    formState={state}
                    formErrors={{}}
                    handleChange={handleChange}
                  />
                </form>
              </div>
            </div>
            <div className="uu-gap-standalone-05rem"></div>
            <ViewGeneratorSimpleV4
              route_freshness={route_freshness}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: (entbox) => {
                  window.alert('*** (Sumbit CREATE entity) ***');
                },
              }}
              viewDefinition={{
                view_key: 'TABLE_OSTALO_V1',
                // table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                table_additional_column_keys_EX: ["parent_destinacija_id", "smestaj_naslov", "smestaj_tab", "smestaj_layer", "smestaj_marker_enabled", "_main_img_url", "komentar ", "_data_digest_valid"],
                table_additional_column_keys: ["parent_destinacija_id",
                  {
                    key: "smestaj_naslov",
                    title: "Naslov"
                  },
                  {
                    key: "_routing_tab",
                    title: "_tab.",
                    minWidth: 96,
                  },
                  {
                    key: "_marker_layer_title",
                    title: "_layer.",
                    minWidth: 96,
                  },
                  {
                    key: "smestaj_layer",
                    title: "Layer",
                    minWidth: 96,
                  },
                  {
                    key: "smestaj_marker_enabled",
                    title: "Marker",
                    minWidth: 80,
                  },
                  {
                    key: "_main_img_url",
                    title: "Main img."
                  },
                  "komentar ", "_data_digest_valid"],
                cbEntityKeyExtractor: (entity, index) => {
                  // console.log('cbEntityKeyExtractor', entity);
                  // return entity.id;
                  return entity.of_id;
                },
                options: {
                  entity_col_disabled: false,
                },
                cbSubmitCreate: (entbox) => {
                  console.log('SUBMIT entbox', entbox);
                  const vr_tablename = 'ym_table_ostalo_v1';
                  const data_for_json = {
                    ...entbox,
                  };
                  const data_json = json_utils.js_to_always_json(data_for_json);
                  const entbox_j = {
                    // vr_tablename,
                    data_json,
                    note: 'proba_note ym_table_ostalo_v1',
                  };
                  console.log('entbox_j', entbox_j);
                  // TODO
                  console.log('TODO submit ostalo...');
                  _zzyourmap_ajax.create(entbox_j, vr_tablename)
                    .then(response => {
                      console.log('response', response);
                      if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                        const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                        //
                        console.log('succes res_payload', res_payload);
                        // REFRESH
                        fetchGetAll();
                        // CLOSE MODAL
                        setUniModalPortableClose();
                      }
                    })
                    .catch(err => {
                      console.error('ERROR cbSubmitCreate ym_table_ostalo_v1', err);
                    });

                },
                cbModalCreate: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormYmostaloV1
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity, payload) => {
                  // return JSX action buttons
                  return (
                    <>
                      <div className="uu-text-wrap uu-gaps-m-05rem">
                        <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'Edit'}
                          iconOnly
                          tooltip='Edit entity'
                          btnColor_TODO={'btn--color-mui-indigo'}
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormYmostaloV1
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT UPDATE entbox', entbox, payload);
                                    const vr_tablename = 'ym_table_ostalo_v1';
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      // vr_tablename,
                                      data_json,
                                      note: 'proba_note ym_table_ostalo_v1',
                                    };
                                    console.log('entbox_j', entbox_j);
                                    const of_id = payload.of_id;
                                    _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                      .then(response => {
                                        console.log('response', response);
                                        if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          //
                                          console.log('succes res_payload', res_payload);
                                          // REFRESH
                                          fetchGetAll();
                                          // CLOSE MODAL
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitCreate ym_table_ostalo_v1', err);
                                      });

                                    ////
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}

                                  mode={'EDIT'}
                                  editorData={{ ...entity }}
                                />),
                            });
                          }}
                        />
                        <UniBtn
                          disabled={entity?._master_flag_deleted === true ? true : false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-toggle-off'
                          title={'Deactivate'}
                          iconOnly
                          tooltip='Deactivate SOFT'
                          themeCompoColorRed
                          btnColor_TODO={'btn--color-mui-indigo'}
                          btnColor={'btn--red'}
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da deaktivirate entity?")) {
                              // TODO
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_flagdeleted({ flag_deleted: true }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_flagdeleted successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_flagdeleted:', err);
                                });

                            }
                          }}
                        />
                        <UniBtn
                          disabled={entity?._master_flag_deleted === true ? false : true}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-toggle-on'
                          title={'Activate'}
                          iconOnly
                          tooltip='Activate SOFT'
                          themeCompoColorRed
                          btnColor_TODO={'btn--color-mui-indigo'}
                          btnColor={'btn--red'}
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da aktivirate entity?")) {
                              // TODO
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_undelete({ flag_deleted: false }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_undelete successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_undelete:', err);
                                });

                            }
                          }}
                        />
                      </div>
                    </>
                  );
                },

              }}
              viewArr={ymostalo_v1_filtered_arr}
              fetching={ymostalo_v1_entities_fetching}
            />

          </div>
        </section>
      </div>
    </>
  );
};


//
const YourmapAdminPanelFormLogin = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  //
  let initialState = {
    username: "",
    password: "",
  };
  let formDefinition = _zzyourmap_formDefinition_adminLogin;
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  //
  return (
    <div className="unicompo-various-content">
      <h3 className="uu-mt-0">Admin Panel Login</h3>
      <div>
        <FormGenerator
          formDefinition={formDefinition}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-1rem"></div>
      <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
        <UniBtn
          disabled={false}
          inline
          wide
          circle_EX
          i="fa fa-sign-in"
          title="Submit"
          handleClick={() => {
            cbDialogSubmit(state);
            // cbDialogCancel();
          }}
        />
        <UniBtn
          disabled={false}
          inline
          wide
          outline
          circle_EX
          i="fa fa-times"
          title="Cancel"
          handleClick={() => { cbDialogCancel(); }}
        />
      </div>
      <div className="uu-gap-standalone-1rem"></div>
    </div>
  );
};


//
const SellerCardPage = (props) => {
  const {
    disabled,
    pageRouteActive,
  } = props;
  if (disabled === true || pageRouteActive === false) {
    return (<></>);
  }
  if (pageRouteActive === true) {
    return (
      <div className="yourmap__admin-panel__heading">
        {
          props.disableHeader !== true && (props.jsxHeader)
        }
        {props.children}
      </div>
    );
  }
  // else
  return (
    <CardCollapsible extraClass={props.extraClass} small={props.small} jsxHeader={props.jsxHeader}>{props.children}</CardCollapsible>
  );
};


//
const SidebarOption = (props) => {

  let handleClick = () => { };

  let clDisabled = '';
  if (props.disabled === true) {
    clDisabled = ' option--disabled';
  } else {
    if (typeof props.handleClick === 'function') {
      handleClick = props.handleClick;
    }
  }

  let clActive = '';
  if (props.active === true) {
    clActive = ' active';
  }
  let hasIcon = false;
  let jsxFontAwsome = null;
  jsxFontAwsome = (
    <span className="icon">
      <i></i>
    </span>
  );
  if (typeof props.i === 'string' && props.i !== '') {
    hasIcon = true;
    jsxFontAwsome = (
      <span className="icon">
        <i className={props.i} aria-hidden="true"></i>
      </span>
    )
  }

  return (
    <div
      className={"option" + clActive + clDisabled}
      onClick={handleClick}
    >
      <div className="bg">{jsxFontAwsome}<span className="title">{props.title}</span></div>
    </div>
  );
};


//
const YourmapAdminPanelLayoutV2 = (props) => {
  const {
    route_freshness,
    setRouteFreshnesssUpdate,
    appState,
    lookup_pack,
  } = props.appPack;
  //
  const detected_env = _zzyourmap_config.ENV_EXTERNAL;
  const [sidebarOpened, setSidebarOpened] = useState(true);
  // let seller_route = 'HOME';
  // const setSellerRoute = () => { };
  const [adminPanelRoute1, setAdminPanelRoute1] = useState('HOME');
  const seller_route = adminPanelRoute1;
  const setSellerRoute = (href_admin_panel) => {
    setAdminPanelRoute1(href_admin_panel);
    setRouteFreshnesssUpdate();
  }
  //
  return (
    <>
      {
        props.adminPanelDebugOpened === true && (
          <>
            <div className="yourmap__admin-panel-debug-section-wrapper-v2">
              <CardCollapsible jsxHeader={<h2>* DEBUG</h2>}>
                <CardCollapsible fullWidth jsxHeader={<h2>* lookup_pack</h2>}>
                  lookup_pack:
                  <div>
                    <JSDisplayValue val={lookup_pack} />
                  </div>
                </CardCollapsible>
                <CardCollapsible fullWidth jsxHeader={<h2>* DEBUG state</h2>}>
                  state:
                  <div>
                    <JSDisplayValue val={appState} />
                  </div>
                </CardCollapsible>
              </CardCollapsible>
            </div>
          </>
        )
      }
      <div className="zzsurvey-app yourmap-theme__scope-admin-panel">
        <div className="zzsurvey__layout">

          <div className={"zzsurvey__layout-drawer" + (sidebarOpened ? " zzsurvey__layout-drawer--opened" : "")}>
            <div className="zzsurvey-app__menu-icon" onClick={() => { setSidebarOpened(false); }}><i className="fa fa-times" aria-hidden="true"></i></div>
            <div className="zzsurvey__layout__fix-header-push"></div>
            <div className="zzsurvey__layout-drawer__pad">
              <div className="sidebar-menu">
                <h3 className="">Yourmap Admin Panel</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'Home/Dashboard'}
                    active={seller_route === 'HOME'}
                    handleClick={() => { setSellerRoute('HOME') }}
                    i="fa fa-home"
                  />
                  <SidebarOption
                    title={'Dokumentacija'}
                    active={seller_route === 'ADMIN_DOCS'}
                    handleClick={() => { setSellerRoute('ADMIN_DOCS') }}
                    i="fa fa-question-circle"
                  />
                  <SidebarOption
                    title={'Image library'}
                    active={seller_route === 'ADMIN_IMAGE_LIBRARY'}
                    handleClick={() => { setSellerRoute('ADMIN_IMAGE_LIBRARY') }}
                    i="fa fa-picture-o"
                  />
                  <SidebarOption
                    title={'Destinacije'}
                    active={seller_route === 'ADMIN_DESTINACIJE'}
                    handleClick={() => { setSellerRoute('ADMIN_DESTINACIJE') }}
                    i="fa fa-map-o"
                  />
                  <SidebarOption
                    disabled
                    title={'Smeštaji'}
                    active={seller_route === 'ADMIN_SMESTAJI'}
                    handleClick={() => { /* setSellerRoute('ADMIN_SMESTAJI') */ }}
                    i="fa fa fa-bed"
                  />
                  <SidebarOption
                    disabled
                    title={'Restorani'}
                    active={seller_route === 'ADMIN_RESTORANI'}
                    handleClick={() => { /* setSellerRoute('ADMIN_RESTORANI') */ }}
                    i="fa fa fa-cutlery"
                  />
                  <SidebarOption
                    title={'Djuture'}
                    active={seller_route === 'ADMIN_DJUTURE'}
                    handleClick={() => { setSellerRoute('ADMIN_DJUTURE') }}
                    i="fa fa-map-marker"
                  />
                  <SidebarOption
                    title={'Blog'}
                    active={seller_route === 'ADMIN_BLOG'}
                    handleClick={() => { setSellerRoute('ADMIN_BLOG') }}
                    i="fa fa-sticky-note-o"
                  />
                </div>
                <h3 className="zzsurvey-temp-hide222">*</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'* v1'}
                    active={seller_route === 'ADMIN_V1'}
                    handleClick={() => { setSellerRoute('ADMIN_V1') }}
                    i="fa fa-shield"
                  />
                  <SidebarOption
                    title={'* Open debug'}
                    active={props}
                    handleClick={() => { props.setAdminPanelDebugOpened(true) }}
                    i="fa fa fa-code"
                  />
                </div>
                <h3>Log out</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'Logout'}
                    active={false}
                    handleClick={() => {
                      // open root route in browser
                      window.location.href = '/'; // This triggers a full page load from the server, discarding any client-side state like form data.
                    }}
                    i="fa fa-sign-out"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="zzsurvey__layout-main">
            <div className="zzsurvey__layout-page-wrapper">
              {
                /*
                <div className="zzsurvey-app__env">{detected_env}</div>
                {
                  detected_env === 'LOCALHOST' && (
                    <div className="zzsurvey-app__env">LOCALHOST ENVIRONMENT</div>
                  )
                }
                {
                  detected_env === 'DEMO' && (
                    <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
                  )
                }
                */
              }

              <div className="zzsurvey__layout-page-header">
                <div className="zzsurvey-app__menu-icon" onClick={() => { setSidebarOpened(true); }}><i className="fa fa-bars" aria-hidden="true"></i></div>
                <div className="zzsurvey__layout-page-header__bar">

                </div>
              </div>

              <div className="zzsurvey__layout__fix-header-push"></div>
              {/*<div className="zzsurvey__layout-page-body-section-dev">
              
              </div>
              */}


              <div className="zzsurvey__layout-page-body">
                <div className="zzsurvey-app__version">Version: {app_build_version_id_zzyourmap}</div>


                <SellerCardPage pageRouteActive={true} disableHeader={true} jsxHeader={<h2>Seller Dashboard</h2>} >
                  <SellerCardPage pageRouteActive={seller_route === 'HOME'} jsxHeader={<h1>Yourmap ADMIN PANEL v2</h1>}>
                    <div className="zzsurvey__dashboard-cards">
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Dokumentacija'}
                            active={seller_route === 'ADMIN_DOCS'}
                            handleClick={() => { setSellerRoute('ADMIN_DOCS') }}
                            i="fa fa-question-circle"
                          />
                          <p>Pomoć, uputstva, dokumentacija...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Image library'}
                            active={seller_route === 'ADMIN_IMAGE_LIBRARY'}
                            handleClick={() => { setSellerRoute('ADMIN_IMAGE_LIBRARY') }}
                            i="fa fa-picture-o"
                          />
                          <p>Pregled i baratanje svim slikama</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Destinacije'}
                            active={seller_route === 'ADMIN_DESTINACIJE'}
                            handleClick={() => { setSellerRoute('ADMIN_DESTINACIJE') }}
                            i="fa fa-map-o"
                          />
                          <p>Turističke destinacije i poddestiancije</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            disabled
                            title={'Smeštaji'}
                            active={seller_route === 'ADMIN_SMESTAJI'}
                            handleClick={() => { /* setSellerRoute('ADMIN_SMESTAJI') */ }}
                            i="fa fa fa-bed"
                          />
                          <p>Smeštaji</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            disabled
                            title={'Restorani'}
                            active={seller_route === 'ADMIN_RESTORANI'}
                            handleClick={() => { /* setSellerRoute('ADMIN_RESTORANI') */ }}
                            i="fa fa fa-cutlery"
                          />
                          <p>Restorani, kafići...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Djuture'}
                            active={seller_route === 'ADMIN_DJUTURE'}
                            handleClick={() => { setSellerRoute('ADMIN_DJUTURE') }}
                            i="fa fa-map-marker"
                          />
                          <p>Djuture restorani, smestaji, prodavnice, servisi...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Blog'}
                            active={seller_route === 'ADMIN_BLOG'}
                            handleClick={() => { setSellerRoute('ADMIN_BLOG') }}
                            i="fa fa-sticky-note-o"
                          />
                          <p>Blog (Ostalo v1 ...ostalo i elementi koji imaju samo marker)</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'* v1'}
                            active={seller_route === 'ADMIN_V1'}
                            handleClick={() => { setSellerRoute('ADMIN_V1') }}
                            i_EX="fa fa-check-square-o"
                            i="fa fa-shield"
                          />
                          <p>Admin panel v1, DEMO-i, eksperimentalne stvari...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'* Open debug'}
                            active={false}
                            handleClick={() => { props.setAdminPanelDebugOpened(true) }}
                            i="fa fa fa-code"
                          />
                          <p>Otvori debug sekciju</p>
                        </div>
                      </div>
                      <div className="xi zzsurvey-temp-hide">
                      </div>
                    </div>
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DOCS'} jsxHeader={<h1>Dokumentacija</h1>} >
                    <YourmapDocs />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_IMAGE_LIBRARY'} jsxHeader={<h1>Image library</h1>} >
                    <YourmapImageLibraryV4
                      appPack={props.appPack}
                      enableAdminFunc={true}
                    />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DESTINACIJE'} jsxHeader={<h1>Destinacije</h1>} >
                    <YourmapAdminDestinationList appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_SMESTAJI'} jsxHeader={<h1>Smeštaji</h1>} >
                    <p>* Premešteno u admin panel v2 djuture.</p>
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_RESTORANI'} jsxHeader={<h1>Restorani</h1>} >
                    <p>* Premešteno u admin panel v2 djuture.</p>
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DJUTURE'} jsxHeader={<h1>Djuture</h1>} >
                    <YourmapAdminYmthingList appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_BLOG'} jsxHeader={<h1>Blog (Ostalo v1)</h1>} >
                    <Komentar>
                      <p>UNDER CONSTRUCTION</p>
                      <p>Napomena: ovo nije finalno, trba isprobati pa da se donesu odluke, pa ćemo korigovati.</p>
                      <p>Napomena: postoji privremeni <b>bug</b> da ove entitete neće da sortira po istom principu kao ostale, tako da obratiš pažnju za sada...</p>
                    </Komentar>
                    <YourmapAdminYmostaloV1List appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_V1'} jsxHeader={<h1>* v1</h1>} >
                    <YourmapAdminPanelLayoutV1 appPack={props.appPack} />
                  </SellerCardPage>
                </SellerCardPage>


              </div>

              <div className="zzsurvey__layout-page-footer">Copyright © 2026 Žarko Turićanin, Dušan Mitrović</div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
};


//
const YourmapAdminPanelLayoutV1 = (props) => {
  const {
    appState,
    show_admin_panel_login,
    lookup_pack,
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.appPack;
  //
  return (
    <>
      <div className="yourmap yourmap__wrapper yourmap__admin-panel-wrapper-v1">
        <CardCollapsible fullWidth jsxHeader={<h1>Yourmap ADMIN PANEL v1</h1>}>
          <section>
            <div className="inner-admin-panel">

              <CardCollapsible jsxHeader={<h2>* DEBUG</h2>}>
                <CardCollapsible fullWidth jsxHeader={<h2>* lookup_pack</h2>}>
                  lookup_pack:
                  <div>
                    <JSDisplayValue val={lookup_pack} />
                  </div>
                </CardCollapsible>
                <CardCollapsible fullWidth jsxHeader={<h2>* DEBUG state</h2>}>
                  state:
                  <div>
                    <JSDisplayValue val={appState} />
                  </div>
                </CardCollapsible>

                <CardCollapsible jsxHeader={<h2>* Admin panel *C</h2>}>
                  *C
                </CardCollapsible>

                <CardCollapsible jsxHeader={<h2>* Admin panel *D</h2>}>
                  *D
                  <div>
                    <UniSpinnerClassic />
                    <UniSpinnerClassic />
                    MMMmmm<UniSpinnerClassic inline />MMmmm
                    INLSMmmm<UniSpinnerClassic inlineSmall />MMmmm
                    IN-S-mmm<UniSpinnerClassic inline s />MMmmm
                    XSmmm<UniSpinnerClassic inline xs /><UniSpinnerClassic inline xs />MMmmm
                    XXSmmm<UniSpinnerClassic inline xxs /><UniSpinnerClassic inline xxs />MMmmm
                    XXXSmmm<UniSpinnerClassic inline xxxs /><UniSpinnerClassic inline xxxs />MMmmm
                    MMMmmm<UniSpinnerClassic xs />MMmmm
                    <UniSpinnerClassic xs />
                    <UniSpinnerClassic xs />
                    <UniSpinnerClassic xxs />
                    <UniSpinnerClassic xxs />
                    <UniSpinnerClassic xxxs />
                    <UniSpinnerClassic xxxs />
                  </div>
                </CardCollapsible>
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Dokumentacija</h2>}>
                <YourmapDocs />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel IMAGE LIBRARY</h2>}>
                <YourmapImageLibraryV4
                  appPack={props.appPack}
                  enableAdminFunc={true}
                />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel DESTINACIJE</h2>}>
                <YourmapAdminDestinationList appPack={props.appPack} />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel SMEŠTAJI</h2>}>
                <p>* Premešteno u admin panel v2 djuture.</p>
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel RESTORANI</h2>}>
                <p>* Premešteno u admin panel v2 djuture.</p>
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel * OSTALO v1</h2>}>
                <Komentar>
                  <p>UNDER CONSTRUCTION</p>
                  <p>Napomena: ovo nije finalno, trba isprobati pa da se donesu odluke, pa ćemo korigovati.</p>
                  <p>Napomena: postoji privremeni <b>bug</b> da ove entitete neće da sortira po istom principu kao ostale, tako da obratiš pažnju za sada...</p>
                </Komentar>
                <YourmapAdminYmostaloV1List appPack={props.appPack} />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>* DEMO BLOG EDITOR Editor.js</h2>}>
                <YourmapEditorjsDemoV1 />
              </CardCollapsible>

              <CardCollapsible fullWidth jsxHeader={<h2>* DEMO Admin Panel mapa</h2>}>
                <YourmapAdminMapDemoV1 appPack={props.appPack} />
              </CardCollapsible>

            </div>
          </section>
        </CardCollapsible>
      </div>
    </>
  );
};



//
export const YourmapAdminPanel = (props) => {
  const {
    appState,
    show_admin_panel_login,
    lookup_pack,
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.appPack;

  const [adminPanelOpened, setAdminPanelOpened] = useState(false);
  const [adminPanelDebugOpened, setAdminPanelDebugOpened] = useState(false);

  if (show_admin_panel_login === true) {
    // continue showing admin panel
  } else { // show nothing
    return (
      <></>
    );
  }

  if (adminPanelOpened === false) {
    const cbDialogSubmit = (loginFormState) => {
      // console.log('SUBMIT LOGIN', loginFormState);
      if (loginFormState && loginFormState.username === "admin" && loginFormState.password === "admin") {
        // LOGIN SUCCESS
        setAdminPanelOpened(true);
        setUniModalPortableClose();
      }
    };
    // const cbDialogCancel = ()=>{ };
    return (
      <>
        <div className="yourmap__admin-panel-temp-enter"><div onClick={() => {
          // setAdminPanelOpened(true);
          setUniModalPortableContent({
            options: {
              large: true,
            },
            jsx: (
              <>
                <YourmapAdminPanelFormLogin
                  cbDialogSubmit={cbDialogSubmit}
                  cbDialogCancel={() => { setUniModalPortableClose(); }}
                />
              </>
            ),
          });
        }}><span>ADMIN PANEL</span></div></div>
      </>
    );
  }
  //
  return (
    <>
      <div className="yourmap__admin-panel-wrapper-v2">
        <YourmapAdminPanelLayoutV2
          appPack={props.appPack}
          adminPanelDebugOpened={adminPanelDebugOpened}
          setAdminPanelDebugOpened={setAdminPanelDebugOpened}
        />
      </div>
    </>
  );
};

